import * as React from 'react';
import styled from 'styled-components';
import MuiDialogContent, { DialogContentProps as MuiDialogContentProps } from '@material-ui/core/DialogContent';

const DialogContentWithProps = React.forwardRef(
    ({ withoutMinWidth, ...rest }: MuiDialogContentProps & { withoutMinWidth?: boolean }, ref) => (
        <MuiDialogContent {...rest} ref={ref} />
    ),
);
DialogContentWithProps.displayName = 'DialogContentWithProps';

const StyledDialogContent = styled(DialogContentWithProps)`
    ${({ withoutMinWidth = false }) => (withoutMinWidth ? '' : 'min-width: 500px;')}
`;

export type DSDialogContentProps = MuiDialogContentProps & {
    withoutMinWidth?: boolean;
};
export const DSDialogContent: React.FC<DSDialogContentProps> = React.forwardRef((props, ref) => (
    <StyledDialogContent {...props} ref={ref} />
)) as any;
DSDialogContent.displayName = 'DSDialogContent';
